// extracted by mini-css-extract-plugin
module.exports = {"root":"PageContentWrapper_root__d34ec","topBottomPadding":"PageContentWrapper_topBottomPadding__RgI8M"};